import React from 'react';
import RelatedProducts from '../RelatedProducts/RelatedProducts';
import bemBlock from '@gik/core/utils/bemBlock';
import { Container, DisableSuggestionsButton, Heading, IPageSectionProps, PageSection } from '@gik/ui';
import { Product } from '@gik/core/models/gik/Product';
import { openPremiumPageUpgradeModal } from '@gik/inkind-page';

export interface IRelatedProductsSectionProps
  extends React.HTMLAttributes<HTMLDivElement>,
    Pick<IPageSectionProps, 'variant'> {
  products?: Product[];
  copy?: string;
  showSuggestedItemsDisableButton?: boolean;
}

export default function RelatedProductsSection({
  products,
  className,
  copy = 'You might also like',
  variant = 'lightblue',
  showSuggestedItemsDisableButton,
}: IRelatedProductsSectionProps): JSX.Element {
  const bem = bemBlock('related-products-section');

  function onClickDisable() {
    return openPremiumPageUpgradeModal({
      initiatedOn: 'inkindPage',
      variant: 'hideSuggestions',
      patchInkindRequest: {
        enableSuggestedProducts: false,
      },
    });
  }

  return (
    <PageSection variant={variant} className={bem(null, null, className)}>
      <Container>
        <Heading className={bem('title')}>
          {copy}
          {showSuggestedItemsDisableButton && (
            <DisableSuggestionsButton className={bem('disable-button')} onClick={onClickDisable} />
          )}
        </Heading>
        <RelatedProducts products={products} />
      </Container>
    </PageSection>
  );
}
